import { campaignHref } from './campaign';

const CATALOGUE = '/products';
const SECONDARY_LABEL = 'View More';

const withSecondary = (primary, secondaryHref) => ({
  primary,
  secondary:
    secondaryHref && secondaryHref !== primary.href
      ? { label: SECONDARY_LABEL, href: secondaryHref }
      : null,
});

/**
 * The two hero buttons for a campaign slide.
 *
 * The primary button repeats the campaign's own target. `View More` is the
 * shopper's way out of the pitch: normally the full catalogue, but the
 * campaign's own page when an `external_link` has taken the primary button
 * off site and that page would otherwise be unreachable from the hero.
 */
export const campaignHeroActions = campaign => {
  const primary = {
    label: campaign?.cta_text || 'Shop Now',
    href: campaignHref(campaign),
  };

  const hasOwnPage = Boolean(campaign?.slug);
  const secondaryHref =
    campaign?.external_link && hasOwnPage
      ? `/campaigns/${campaign.slug}`
      : CATALOGUE;

  return withSecondary(primary, secondaryHref);
};

/**
 * The two hero buttons for the fallback `hero_banners` slide.
 *
 * A banner that already points at the catalogue gets a single button rather
 * than two that land in the same place.
 */
export const bannerHeroActions = banner =>
  withSecondary(
    {
      label: banner?.button_text || 'Shop Now',
      href: banner?.redirect_link || CATALOGUE,
    },
    CATALOGUE
  );
